import { FC } from "react";
import { Center, Text } from "@chakra-ui/react";

export const MainPageLimitClosed: FC = () => {
  return (
    <Center flex="1" flexDirection="column" pb="100px">
      <Text variant="brand" textAlign="center">
        У вас сейчас нет активных договоров
      </Text>
    </Center>
  );
};
